export default __webpack_public_path__ + "static/21-0c2d37681ce02cd0641d9afe56b0535e.png";